import { render, staticRenderFns } from "./BeneficioListAddNew.vue?vue&type=template&id=f9bed810&"
import script from "./BeneficioListAddNew.vue?vue&type=script&lang=js&"
export * from "./BeneficioListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./BeneficioListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports